const p=["mp4"],g=["mp3","m4a","ocg","ogg"],o=["jpeg","jpg","png","webp"],e=["pdf","zip"];export{g as AUDIO_FILE_TELEGRAM,e as DOCUMENT_FILE_TELEGRAM,o as IMAGE_FILE_TELEGRAM,p as VIDEO_FILE_TELEGRAM};
//# sourceMappingURL=fileTypesTelegram.js.map
